import { useState, useRef, useEffect } from 'react';
import HumansInSpacePill from './HumansInSpacePill.jsx';
import { useNightVision } from '../hooks/useNightVision.js';

export default function MobileTopBar({ onOpenSearch, push, onOpenDisplay, onOpenLocation, children }) {
  const [night, toggleNight] = useNightVision();
  const [toolsOpen, setToolsOpen] = useState(false);
  const settingsRef=useRef(null), menuRef=useRef(null);
  const closeSettings=()=>{setToolsOpen(false);settingsRef.current?.focus();};
  useEffect(()=>{if(toolsOpen)menuRef.current?.querySelector('button')?.focus();},[toolsOpen]);
  return (
    <header className="og-compact-header">
      <span className="og-wordmark">Orbital <b>Glass</b></span>
      {children}
      <HumansInSpacePill compact />
      <button onClick={onOpenSearch} title="Search satellites">Search</button>
      <button ref={settingsRef} className="og-settings-button" aria-describedby={push?.error ? 'push-settings-status' : undefined} onClick={() => setToolsOpen(on => !on)} aria-expanded={toolsOpen} aria-controls="compact-tools">Settings{push?.error && <span className="og-settings-notice" aria-hidden="true" />}</button>
      {push?.error && <span id="push-settings-status" className="og-sr-only">Push alerts need attention</span>}
      {toolsOpen && <div ref={menuRef} role="region" aria-label="Settings" id="compact-tools" className="og-tools-menu" onKeyDown={e => { if (e.key === 'Escape') {e.stopPropagation();closeSettings();} }}>
        <div className="og-tools-heading">Settings <button onClick={closeSettings}>Close</button></div>
        {push && push.permission !== 'unsupported' && <button
          onClick={push.subscribed ? push.unsubscribe : push.requestPush}
          disabled={push.pending || push.permission === 'denied'} aria-pressed={push.subscribed} aria-describedby={push.error ? 'push-settings-error' : undefined}>
          <i className="ti ti-bell" aria-hidden="true" /> {push.pending ? 'Saving alerts…' : push.subscribed ? 'Turn off push alerts' : push.permission === 'denied' ? 'Alerts blocked in browser settings' : push.error ? 'Retry push alerts' : 'Enable push alerts'}
        </button>}
        {push?.error && <p id="push-settings-error" role="alert" className="og-settings-error">Push alerts: {push.error}</p>}
        <button onClick={toggleNight} aria-pressed={night}><i className="ti ti-moon" aria-hidden="true" /> {night ? 'Disable night vision' : 'Enable night vision'}</button>
        <button onClick={()=>{closeSettings();onOpenDisplay();}}>Display options</button>
        {onOpenLocation && <button onClick={()=>{closeSettings();onOpenLocation();}}>Observing location</button>}
      </div>}
    </header>
  );
}
